import React, { type PropsWithChildren, memo } from "react";
import ListVariant, { type ListVariants } from "./List.styles";

export type ListVariantsType = keyof typeof ListVariants;

export type ListProps = {
    id?: string;
    tag?: "ul" | "ol" | "dl";
    variant: ListVariantsType;
    columns?: number;
    hidden?: boolean;
    skeleton?: boolean;
    dataCpdqm?: "ignore";
};

const List: React.FC<PropsWithChildren<ListProps>> = (props) => {
    const { id, tag = "ul", variant, columns, hidden, skeleton, dataCpdqm, children } = props;
    return (
        <ListVariant
            id={id}
            as={tag}
            variant={variant}
            columns={columns}
            hidden={hidden}
            skeleton={skeleton}
            role={tag === "dl" ? undefined : "list"}
            data-cpdqm={dataCpdqm}
        >
            {children}
        </ListVariant>
    );
};

export default memo(List);
